import Main from './components/Main';

const Tutorial = () => {
    return <Main />;
};

export default Tutorial;
